module.exports = __webpack_public_path__ + "static/media/PWM.ab71ed08.png";